import { type ImageAssetWithAltText, RadioGroup } from '@fhs/ui';

import { ListItemGroup, type ListItemGroupProps } from '../list-item-group-section/list-item-group';
import { ListItemRadio } from '../list-item-group-section/list-item-radio';

type ListItemGroupRadioGroupProps = Omit<ListItemGroupProps, 'items'> & {
  value: string;
  options: Array<{
    value: string;
    title: string;
    subtitle?: string;
    image?: ImageAssetWithAltText;
    disabled?: boolean;
  }>;
  onChange: (nextPickerAspectOptionId: string) => void;
};

export function ListItemGroupRadioGroup({
  value,
  onChange,
  options = [],
  ...listItemGroupProps
}: ListItemGroupRadioGroupProps) {
  return (
    <RadioGroup value={value} onChange={onChange}>
      <ListItemGroup
        {...listItemGroupProps}
        items={options.map(opt => {
          return {
            id: opt.value,
            render: listItemProps => (
              <ListItemRadio
                value={opt.value}
                title={opt.title}
                image={opt.image}
                subtitle={opt.subtitle}
                disabled={opt.disabled}
                {...listItemProps}
              />
            ),
          };
        })}
      />
    </RadioGroup>
  );
}
